import * as React from "react";
import { Modal } from "antd";

interface aboutModalProps {
  visible: boolean;
  afterClose: () => void;
}

const AboutModal: React.FC<aboutModalProps> = ({ visible, afterClose }) => {
  return (
    <Modal
      title="Бидний тухай"
      footer={null}
      width={300}
      onCancel={afterClose}
      visible={visible}
      centered
    >
      <p>CallPro LLC</p>
    </Modal>
  );
};

export default AboutModal;
